import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../common/hooks/hooks";
import { useGetCartQuery } from "../../api/cartApi";
import { openProductModal } from "../../../product/components/common/ProductModal/productModalSlice";
import RelatedProducts from "../../../product/components/common/RelatedProducts";

const CartPageCrossSellProducts: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data: cart } = useGetCartQuery();

  const crossSellIds = cart?.crossSellIds || [];

  // If there are no cross-sells, this component renders nothing.
  if (crossSellIds.length === 0) {
    return null;
  }

  const handleOpenQuickView = (productId: number) => {
    dispatch(openProductModal({ productId }));
  };

  // Custom breakpoints for the Cart Page context.
  // NOTE: The cart page has a sidebar on Desktop. Even at 1024px viewport,
  // the content area is effectively tablet-sized. We need fewer slides per view.
  const cartContextBreakpoints = {
    250: { slidesPerView: 1, spaceBetween: 20 },
    500: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 20 },
  };

  return (
    <div className="cart-page-crossell-products">
      <RelatedProducts
        productIds={crossSellIds}
        title={t("relatedProducts.crossSellsTitle")}
        onQuickViewClick={handleOpenQuickView}
        breakpoints={cartContextBreakpoints}
      />
    </div>
  );
};

export default CartPageCrossSellProducts;
